import React from 'react';
import MobileWrapper from  '../gui/MobileWrapper';


class index extends React.Component {
	render() {
		return (
			<MobileWrapper topNav={false}>
				<div className="content-padding">
					Impressum
				</div>
			</MobileWrapper>
		);
	}
}

export default index;	


// WEBPACK FOOTER //
// ./src/imprint/index.js